import angular from 'angular';
/**
 * @ngdoc module
 * @name flowingly.runner.nav.categories
 * @module flowingly.runner.nav.categories
 * @description This module configures the page used to maintenance of all flows.
 */
angular.module('flowingly.runner.nav.categories', []);